/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {I18nStringItem} from './i18nStringItem';
import {KeyValueOfstringAndstring} from './keyValueOfstringAndstring';


export interface TransactionalEmailConfDTO {
    code: string;
    codeDataView?: string;
    codesTemplateHtml?: Array<string>;
    cron?: string;
    defaultLanguage: string;
    description?: string;
    dictionary?: Array<I18nStringItem>;
    enable: boolean;
    etl?: KeyValueOfstringAndstring;
    id?: string;
    idSaveQuery?: string;
    linkShowNav?: boolean;
    marketingTag?: string;
    name: string;
    partner?: string;
    previewText?: string;
    provider?: string;
    replyToEmail?: string;
    senderEmail?: string;
    senderName?: string;
    sendTo?: string;
    subject?: string;
    templateId?: number;
    tenant?: string;
    triggerCodeEtl?: string;
    type?: TransactionalEmailConfDTO.TypeEnum;
    utmCampaign?: string;
    utmContent?: string;
    utmMedium?: string;
    utmSource?: string;
    campaignId?: number;
}
export namespace TransactionalEmailConfDTO {
    export type TypeEnum = 'MARKETING' | 'TRANSACTIONAL';
    export const TypeEnum = {
        MARKETING: 'MARKETING' as TypeEnum,
        TRANSACTIONAL: 'TRANSACTIONAL' as TypeEnum
    };
}
